module.exports = __webpack_public_path__ + "videogular.535a6d96e96b8bc4549f.eot";


//////////////////
// WEBPACK FOOTER
// /Users/thiago/Documents/projetos/biblioteco-angular/node_modules/videogular2/fonts/videogular.eot?hj1wei
// module id = ../../../../videogular2/fonts/videogular.eot?hj1wei
// module chunks = styles